import Vue from 'vue'
import { extend } from 'vee-validate'
import { required, email, numeric, confirmed } from 'vee-validate/dist/rules'
import { validate as rutValidation } from 'v-rut/dist/VeeRutValidator'
import vRut from 'v-rut'

Vue.use(vRut, {
  inject: true,
})

export default ({ i18n }, inject) => {
  extend('requiredField', {
    ...required,
    params: ['value'],
    message: (field) =>
      i18n.t('errorMessages.requiredField', {
        field: i18n.t(`label.${field}`).toLowerCase(),
      }),
  })

  extend('required', {
    ...required,
    message: i18n.t(`errorMessages.required`),
    computesRequired: true,
  })

  extend('email', {
    ...email,
    message: i18n.t(`errorMessages.validEmail`),
  })

  extend('checkboxValidation', {
    validate(value, args) {
      return value.length >= args.length
    },
    params: ['length'],
    message: i18n.t(`errorMessages.required`),
  })

  extend('numeric', {
    ...numeric,
    message: i18n.t(`errorMessages.onlyNumbers`),
  })

  extend('rut', {
    validate: rutValidation,
    message: i18n.t(`errorMessages.validRut`),
  })

  extend('minLength', {
    validate(value, args) {
      return value.length >= args.length
    },
    params: ['length'],
    message: (field, { length }) =>
      i18n.t(`errorMessages.veryShort`, { length }),
  })

  extend('maxLength', {
    validate(value, args) {
      return value.length <= args.length
    },
    params: ['length'],
    message: (field, { length }) =>
      i18n.t(`errorMessages.veryLarge`, { length }),
  })

  extend('confirmed', {
    ...confirmed,
    message: i18n.t(`errorMessages.passwordMatch`),
  })
}

Vue.directive('input-rut', {
  bind(el) {
    el.value = formatRut(el.value)
  },
  update(el) {
    if (el.value < 3) return false
    el.value = formatRut(el.value)
  },
})

function formatRut(val) {
  if (val.length < 2) return val
  return (
    clean(val)
      .slice(0, -1)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') +
    '-' +
    clean(val).slice(-1)
  )
}

function clean(val) {
  return val.replace(/[^[0-9kK]/g, '')
}

Vue.directive('input-numeric', {
  bind(el) {
    el.value = isNumeric(el.value) ? el.value : ''
  },
  update(el) {
    if (el.value < 3) return false
    el.value = isNumeric(el.value) ? el.value : ''
  },
})

function isNumeric(str) {
  if (typeof str !== 'string') return false // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ) // ...and ensure strings of whitespace fail
}
